import React, {Component} from 'react'

import styles from './SpanLink.less'

const {
    'span-link': link_class,
    'span-link_pseudo': link_pseudo_class,
} = styles

export default class ButtonLink extends Component {
    render() {
        const {className, children, pseudo, _ref, ...props} = this.props
        const classes = [link_class]

        if (className) {
            classes.push(className)
        }

        if (pseudo) {
            classes.push(link_pseudo_class)
        }

        return (
            <span className={classes.join(' ')} ref={_ref ? _ref : () => {
            }} {...props}>
				{children}
			</span>
        )
    }
}